import { opportunitySyncProfilesService } from '@/services/opportunity-sync-profiles.service';

const initialState = () => ({
  fieldMappings: [],
  fieldOptions: {},
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getFieldMappings({ commit }, { syncProfileId, scope, formOnly = false }) {
    commit('GET_FIELD_MAPPINGS');

    return opportunitySyncProfilesService.getFieldMappings({ syncProfileId, scope, formOnly }).then(
      (response) => {
        commit('SUCCESS_GET_FIELD_MAPPINGS', response);
        return response;
      },
      (error) => {
        commit('ERROR_GET_FIELD_MAPPINGS', error);
        throw error;
      },
    );
  },
  getFieldMappingOptions({ commit }, { syncProfileId, fieldId }) {
    return opportunitySyncProfilesService.getFieldMappingOptions({ syncProfileId, fieldId }).then(
      (response) => {
        commit('SET_FIELD_OPTIONS', { fieldId, options: response });
        return response;
      },
      (error) => {
        throw error;
      },
    );
  },
  resetFieldMappings({ commit }) {
    commit('RESET_FIELD_MAPPINGS');
  },
};

const mutations = {
  GET_FIELD_MAPPINGS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS_GET_FIELD_MAPPINGS(state, fieldMappings) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.fieldMappings = fieldMappings;
  },
  ERROR_GET_FIELD_MAPPINGS(state, error) {
    state.status = {
      error,
      pending: false,
      resolved: false,
      rejected: true,
    };
    state.fieldMappings = [];
  },
  SET_FIELD_OPTIONS(state, { fieldId, options }) {
    state.fieldOptions = {
      ...state.fieldOptions,
      [fieldId]: options,
    };
  },
  RESET_FIELD_MAPPINGS(state) {
    Object.assign(state, initialState());
  },
};

const getters = {
  fieldMappings: (state) => state.fieldMappings,
  fieldOptions: (state) => state.fieldOptions,
  pending: (state) => state.status.pending,
  error: (state) => state.status.error,
};

export const syncFieldMappings = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
